export const formatAmountINR = (amount: number | undefined | null): string => {
    if (amount == null || isNaN(amount)) return "-";
    return "₹ " + amount.toLocaleString("en-IN");
  };
  